module.exports = __webpack_public_path__ + "img/online-players.73dea956.svg";